import React from "react";
import { ArrowLeft, Copy, KeyRound, MessageCircle } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { btnGhost } from "@/components/Brand";

/** Project heading plus the client share link and access-code row. */
export const ProjectInfo = ({ project, clientLink, accessCode, onBack, onCopy, onWhatsapp, onResetCode }) => {
  const { t } = useI18n();

  return (
    <>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <button onClick={onBack} data-testid="back-to-dashboard-link"
            className="inline-flex items-center gap-2 min-h-[44px] text-[11px] tracking-[0.18em] uppercase text-[#A8A8A8] hover:text-[#D4AF37] mb-3">
            <ArrowLeft size={14} /> {t("dashboard")}
          </button>
          <p className="font-mono-accent text-xs text-[#D4AF37]">{project.code}</p>
          <h1 data-testid="project-title-heading" className="mt-2 text-4xl sm:text-5xl tracking-tighter font-medium">
            {project.title}
          </h1>
          <p className="mt-2 text-sm text-[#A8A8A8]">{project.client_name || "—"} · {project.client_email || "—"}</p>
        </div>
        <span className="font-mono-accent text-[10px] tracking-[0.2em] uppercase text-[#D4AF37] border border-[#D4AF37]/40 px-3 py-1.5">
          {project.status === "submitted" ? t("submitted") : t("awaiting_client")}
        </span>
      </div>

      <section className="border border-[#2A2A2A] bg-[#0B0B0B] p-6 lg:p-8">
        <p className="eyebrow mb-4">{t("client_link")}</p>
        <div className="flex flex-col sm:flex-row gap-4">
          <code data-testid="client-link-value" className="flex-1 font-mono-accent text-xs text-[#D4AF37] break-all bg-[#050505] border border-[#2A2A2A] px-4 py-3">
            {clientLink}
          </code>
          <button data-testid="copy-client-link-btn" onClick={onCopy} className={btnGhost}>
            <Copy size={13} /> {t("copy")}
          </button>
          <a data-testid="preview-gallery-link" href={clientLink} target="_blank" rel="noreferrer" className={btnGhost}>
            {t("preview")}
          </a>
          {project.client_phone && (
            <button data-testid="whatsapp-invite-btn" onClick={() => onWhatsapp("invite")} className={btnGhost}>
              <MessageCircle size={13} /> {t("send_invite_whatsapp")}
            </button>
          )}
          {project.client_email && (
            <button data-testid="reset-access-code-btn" onClick={onResetCode} className={btnGhost}>
              <KeyRound size={13} /> {t("reset_code")}
            </button>
          )}
        </div>
        {accessCode && (
          <p className="mt-4 font-mono-accent text-xs text-[#D4AF37]" data-testid="access-code-value">
            {t("access_code_label")}: {accessCode}
          </p>
        )}
      </section>
    </>
  );
};
